import angular from "angular";
import { Lang } from "Roblox";

let inventory = angular.module("inventory", ["assetsExplorer", "inventoryAppTemplates", "recommendations", "cursorPagination"])
    .config(["languageResourceProvider", function (languageResourceProvider) {
        languageResourceProvider.setLanguageKeysFromFile(Lang["Feature.Recommendations"]);
    }]);

export default inventory;